import { Injectable } from '@jkhy/frontend-utils/di';
import { LoginParametersClient } from '@treasury/api/bo';
import { LoginParameters } from '../company-user-settings/entities/login-parameters.entity';

@Injectable()
export class FiUserSettingsService {
    constructor(private readonly loginParametersClient: LoginParametersClient) {}

    public async getLoginParameters(): Promise<LoginParameters> {
        const response = await this.loginParametersClient.loginParametersGet({ type: 'fi' });
        return LoginParameters.from(response.data);
    }

    public async updateLoginParameters(params: LoginParameters): Promise<LoginParameters> {
        const response = await this.loginParametersClient.loginParametersPut(
            params.id,
            params.toDto()
        );
        return LoginParameters.from(response.data);
    }

    public async revertToDefaults(id: number): Promise<LoginParameters> {
        const response = await this.loginParametersClient.loginParametersDefaults(id, {
            isCompanyParameter: false,
        });
        return LoginParameters.from(response.data);
    }
}
